import {
  mapState, mapGetters, mapMutations,
} from 'vuex';

import { AuthService } from '@/auth';
import { AuthRoutes } from '@/auth/mixins';

import authMessages from '@/auth/data/auth.messages';

// @vue/component
export default {
  mixins: [
    AuthRoutes,
  ],
  data() {
    return {
      errorAlert: null,
      inputs: {
        email: {
          properties: {
            label: 'Email address',
            'label-icon': 'far fa-envelope',
            name: 'email',
            required: true,
            type: 'email',
            'validation-rules': 'required|email',
          },
          value: '',
        },
        password: {
          properties: {
            label: 'Password',
            name: 'password',
            required: true,
            'validation-rules': 'required',
          },
          value: '',
        },
        rememberMe: {
          properties: {
            label: 'Keep me logged in',
            class: 'my-0',
          },
          value: false,
        },
      },
      requestInProgress: false,
      showPasswordAsText: false,
    };
  },
  computed: {
    ...mapGetters(['invalidLoginCountExceedsWarningLimit']),
    ...mapState(['invalidLoginCount']),
    ...mapState({
      contactSupportLink: state => state.config.contactSupportLink,
    }),
  },
  methods: {
    ...mapMutations(['setInvalidLoginCount']),
    async login() {
      this.requestInProgress = true;

      try {
        const credentials = {
          login: this.inputs.email.value,
          password: this.inputs.password.value,
          rememberMe: this.inputs.rememberMe.value,
        };
        await AuthService.login(credentials);
        this.setInvalidLoginCount(0);

        this.$router.push(this.routes.redirect);
      } catch (error) {
        this.inputs.password.value = '';
        this.$refs.observer.reset();
        const statusCode = _.get(error, 'response.status');
        if (statusCode === 401) {
          this.setInvalidLoginCount(this.invalidLoginCount + 1);
        }

        const message = (authMessages.login[statusCode] || authMessages.login.error).message(this.invalidLoginCountExceedsWarningLimit);
        this.errorAlert = {
          message,
          includePasswordResetLink: statusCode === 401,
          includeContactHelpdeskLink: [403, undefined].includes(statusCode),
          status: statusCode,
        };
      }

      this.requestInProgress = false;
    },
  },
};
